module.exports = __webpack_public_path__ + "img/login_background-min.293777f0.png";